import * as t from "io-ts";
import isoDateTimeForJSON from "./isoDateTimeForJSON";
import nullable from "./nullable";
import { webBookerT } from "./web-booking";
export const createOrganisationT = t.strict({
    name: t.string,
    cvr: t.string,
    ref: t.string,
    address: t.string,
    postcode: t.string,
    city: t.string,
    country: t.string,
    adminFirst: t.string,
    adminLast: t.string,
    adminTitle: t.string,
    adminEmail: t.string,
    adminPhone: t.string,
    liteVersion: t.boolean,
    createUser: t.boolean,
    partner: t.union([t.null, t.literal("DTL"), t.literal("Padborg")]),
});
const locationT = t.strict({
    lon: t.number,
    lat: t.number,
});
export const financeIntegrationT = t.union([
    t.literal("Business Central"),
    t.literal("E-CONOMIC"),
    t.literal("Tripletex"),
    t.literal("PowerOffice"),
]);
const financeIntegrationHealthT = t.strict({
    label: t.string,
    color: t.union([
        t.literal("success"),
        t.literal("danger"),
        t.literal("warning"),
        t.literal("secondary"),
        t.literal("info"),
    ]),
});
export const organisationT = t.strict({
    id: t.string,
    adminFirst: t.string,
    adminLast: t.string,
    adminTitle: t.string,
    adminEmail: t.string,
    adminPhone: t.string,
    ref: t.string,
    cvr: t.string,
    address: t.string,
    postcode: nullable(t.string),
    city: nullable(t.string),
    country: t.string,
    createdAt: isoDateTimeForJSON,
    systemAdmin: t.boolean,
    defaultTeamId: nullable(t.string),
    name: t.string,
    financeIntegration: nullable(financeIntegrationT),
    financeIntegrationHealth: nullable(financeIntegrationHealthT),
    webBookingEnabled: nullable(t.boolean),
    searchOrigin: nullable(locationT),
    apiKey: nullable(t.string),
    usersCount: t.string,
    microsoftTenantId: nullable(t.string),
});
export const organisationsT = t.array(organisationT);
const orgUserT = t.strict({
    id: t.string,
    first: t.string,
    last: t.string,
    email: t.string,
    created_at: t.string,
    default_team_id: t.string,
    role: nullable(t.union([t.literal("ORG_ADMIN"), t.literal("DISPATCHER")])),
    last_active_at: nullable(t.string),
    disabled_at: nullable(t.string),
    is_support_user: t.boolean,
    created_by: nullable(t.string),
});
export const orgUsersT = t.array(orgUserT);
export const createSupportUserInputT = t.strict({
    firstName: t.string,
    lastName: t.string,
    email: t.string,
});
const clientWebBookingT = t.strict({
    id: t.string,
    name: t.string,
    hasApiKey: t.boolean,
    webBookers: t.array(webBookerT),
});
export const orgDeletionJobT = t.strict({
    id: t.string,
    status: t.union([
        t.literal("PENDING"),
        t.literal("IN_PROGRESS"),
        t.literal("COMPLETED"),
        t.literal("FAILED"),
    ]),
    currentStepName: nullable(t.string),
    rowsDeletedTotal: t.number,
    error: nullable(t.string),
});
const orgDeletionScheduleT = t.strict({
    id: t.string,
    daysRemaining: t.number,
    scheduledForFormatted: t.string,
});
export const orgDeletionAuditT = t.strict({
    orgName: t.string,
    orgRef: t.string,
    triggeredByEmail: t.string,
});
export const orgDeletionStatusT = t.strict({
    job: orgDeletionJobT,
    stepIndex: nullable(t.number),
    totalSteps: t.number,
    audit: nullable(orgDeletionAuditT),
});
const outgoingInvoiceStatusT = t.union([
    t.literal("INVOICE_CREATED"),
    t.literal("INVOICE_SENT"),
    t.literal("INVOICE_FAILED"),
]);
const outgoingInvoicingModeT = t.union([
    t.literal("DIRECT"),
    t.literal("CONSOLIDATED"),
]);
export const outgoingInvoiceForAdminT = t.strict({
    date: nullable(t.string),
    otherRef: nullable(t.string),
    status: outgoingInvoiceStatusT,
    invoicingMode: outgoingInvoicingModeT,
    attachmentFileIds: t.array(t.string),
});
export const outgoingInvoicesForAdminT = t.array(outgoingInvoiceForAdminT);
export const organisationWithDetailsT = t.strict({
    org: organisationT,
    orgUsers: orgUsersT,
    defaultSearchOrigin: locationT,
    webBookers: nullable(t.array(webBookerT)),
    clientsWebBooking: t.array(clientWebBookingT),
    unassignedWebBookers: nullable(t.array(webBookerT)),
    microsoftSsoGroupAccessEnabled: t.boolean,
    activeDeletionJob: nullable(orgDeletionJobT),
    activeDeletionSchedule: nullable(orgDeletionScheduleT),
});
export const archiveRoutesBeforeDateInputT = t.strict({
    date: t.string,
});
//# sourceMappingURL=organisations.js.map